module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "content-icons-ui": "static-1.2415"
    },
    "depPathPrefixes": {
      "content-icons-ui": "/content-icons-ui/static-1.2415"
    },
    "bundlingPackage": "deal-plans-ui",
    "bundlingPackageVersion": "static-1.2290",
    "project": "content-icons-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};